var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"print-page"},[_c('PrintMember',{attrs:{"value":_vm.printData,"board":_vm.boardData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }